import { render, staticRenderFns } from "./BaseSliderNavigation.vue?vue&type=template&id=dcdad9da&"
import script from "./BaseSliderNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseSliderNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports